// Apple Pay merchant configuration (iOS only, CPS-26590 Task 5).
//
// Single, swappable source for the merchant identifier
// @adyen/react-native's ApplePayConfiguration needs
// (Configuration.applepay.merchantID) and the label shown on the Apple Pay
// sheet's payment summary row. AdyenCardAddSheet is the only importer.
//
// Merchant id must match the entitlements file used by that build:
// - production  → ios/Aimo/Aimo.production.entitlements
// - dev/staging → ios/Aimo/Aimo.entitlements (TEST merchant)
// A mismatch fails at the Apple Pay sheet, not at build time.

import config from 'config/config';

const isProduction = String(config.dotEnvFilenameVar || '')
  .toLowerCase()
  .includes('production');

export const APPLE_PAY_MERCHANT_ID = isProduction
  ? 'merchant.com.adyen.aimoPark'
  : 'merchant.com.adyen.aimoPark.test';

// Shown on the Apple Pay sheet's payment summary row.
export const APPLE_PAY_MERCHANT_NAME = 'Aimo App';

// Apple Pay recurring-mandate management URL (iOS). Apple shows this on the pay
// sheet as the page where the user can view/cancel the stored mandate; it must
// be an https web page (Wallet opens it in the browser), pointing at the web
// payment-methods page. PLACEHOLDER host until the real per-env URL lands — swap
// the right-hand side (or read from config.js) before enabling in prod. iOS
// deep-linking into the app needs universal links (Associated Domains + AASA),
// which are not set up yet, so on iOS this opens the web page in Safari.
export const APPLE_PAY_MANAGEMENT_URL =
  'https://app.aimopark.io/account/my-payment-methods';
